// src/components/MaintenanceBanner.js - service notice above the whole app.
//
// Audit FL-45: besides the compile-time switch in src/maintenance.js, the banner can be
// turned on without a rebuild by editing /maintenance.json on the web server, e.g.
//   {"enabled": true, "type": "warning", "message": "Dnes od 22:00 probíhá údržba."}
// It is a full-width strip above the top bar (it no longer covers the logo on phones).
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertCircle, Info } from 'lucide-react';
import { maintenanceConfig } from '../maintenance';

const STYLES = {
  error: 'bg-red-50 text-red-800 border-red-200',
  warning: 'bg-amber-50 text-amber-900 border-amber-200',
  info: 'bg-blue-50 text-blue-800 border-blue-200',
};

const MaintenanceBanner = () => {
  const [runtime, setRuntime] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get('/maintenance.json', { params: { t: Date.now() }, timeout: 5000 })
      .then((res) => {
        const data = res && res.data;
        if (!cancelled && data && typeof data === 'object' && data.enabled && data.message) setRuntime(data);
      })
      .catch(() => {
        /* no file or not reachable - nothing to show */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const notice = runtime || (maintenanceConfig.isMaintenanceMode ? maintenanceConfig : null);
  if (!notice) return null;

  const type = STYLES[notice.type] ? notice.type : 'warning';
  const Icon = type === 'info' ? Info : AlertCircle;

  return (
    <div role="status" className={`border-b px-4 py-2 text-sm print:hidden ${STYLES[type]}`}>
      <div className="mx-auto flex max-w-7xl items-start gap-2">
        <Icon className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <span>{notice.message}</span>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
